export default "__VITE_ASSET__CHTGVpN9__"